// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__Ml-_3","rootCenter":"LoadMoreObserver_rootCenter__3XF8u","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__G8ReT"};